module.exports = __webpack_public_path__ + "img/ic_default_head.f25f8570.png";